import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';

export default class ExploreWarehouseReport extends Base {
    constructor(props) {
        super(props);
        this.state = {
            controllerName: 'report',
            data: null,
            loading: true,
            id_to_remove: null,
            phrase: '',
            ids: [],
            filters: {},
            selectedGroup: [],
            selectedKol: [],
            selectedMoein: [],
            selectedTafsil: [],
        };
    }
    componentDidMount() {
        this.refreshData(null,'explore/warehouse');
    }
    renderForm() {
        return <div>
            <div className="card card-bordered card-preview">
                <div className="card-inner">
                    <div className="tab-content">
                        <div className="tab-pane active" id="group">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="card-inner-group">
                                        <div className="card-inner p-0">
                                            <div className="nk-tb-list nk-tb-ulist">
                                                <div className="nk-tb-item nk-tb-head">
                                                    <div className="nk-tb-col tb-col-sm"><span className="sub-text text-center">شرح انبار</span></div>
                                                    <div className="nk-tb-col tb-col-sm"><span className="sub-text text-center">کد انبار</span></div>
                                                    <div className="nk-tb-col tb-col-sm"><span className="sub-text text-center">شرح کالا</span></div>
                                                    <div className="nk-tb-col tb-col-sm"><span className="sub-text text-center">کد کالا</span></div>
                                                    <div className="nk-tb-col tb-col-sm"><span className="sub-text text-center">ورودی</span></div>
                                                    <div className="nk-tb-col tb-col-sm"><span className="sub-text text-center">خروجی</span></div>
                                                    <div className="nk-tb-col tb-col-sm"><span className="sub-text text-center">موجودی</span></div>
                                                </div>
                                                {this.state.data.records.map((record, index) =>
                                                    <div className="nk-tb-item">
                                                        <div className="nk-tb-col tb-col-lg">
                                                            <span className="sub-text text-center">{record.warehouseTitle}</span>
                                                        </div>
                                                        <div className="nk-tb-col tb-col-lg">
                                                            <span className="sub-text text-center">{record.warehouseCode}</span>
                                                        </div>
                                                        <div className="nk-tb-col tb-col-lg">
                                                            <span className="sub-text text-center">{record.stuffName}</span>
                                                        </div>
                                                        <div className="nk-tb-col tb-col-lg">
                                                            <span className="sub-text text-center">{record.stuffCode}</span>
                                                        </div>
                                                        <div className="nk-tb-col tb-col-lg">
                                                            <span className="sub-text text-center">{this.money(record.in)}</span>
                                                        </div>
                                                        <div className="nk-tb-col tb-col-lg">
                                                            <span className="sub-text text-center">{this.money(record.out)}</span>
                                                        </div>
                                                        <div className="nk-tb-col tb-col-lg">
                                                            <span className="sub-text text-center">{this.money(record.inventory)}</span>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.isEmpty(this.state.data.global.companies) ? this.renderNoCompanyRegister() : this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />
            ];

        return contents;
    }
}